import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
    refresh: false,
    payrole_employee_structure_details :{},
    selectedRegime: '',
    isVerified: !!sessionStorage.getItem("verify-token"),
};

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setSelectedRegime: (state, action) => {
            state.selectedRegime = action.payload;
        },
        setVerified(state, action) {
            state.isVerified = action.payload;
          },

    },
});

export const { setRefresh , setSelectedRegime, setVerified } = commonSlice.actions;
export default commonSlice.reducer;
